import { ToastService } from '../services/toast.service';

export const API_RATE_LIMIT_MESSAGE =
  'Rate limit reached. Try again in 10 seconds.';

export function isApiRateLimited(response: Response): boolean {
  return response.status === 429;
}

export function notifyApiRateLimited(toast: ToastService): void {
  toast.raise('warning', API_RATE_LIMIT_MESSAGE);
}
